import React from 'react';

import { Beach } from './menu-icons/beach';
import { Building } from './menu-icons/building';
import { CloudDismiss } from './menu-icons/cloud-dismiss';
import { Star } from './menu-icons/star';
import { Warning } from './menu-icons/warning';

import { CloudCheckmark } from './surface-icons/cloud-checkmark';
import { DataTrending } from './surface-icons/data-trending';
import { Dumbbell } from './surface-icons/dumbbell';
import { People } from './surface-icons/people';
import { StarHeart } from './surface-icons/star-heart';

export const MenuIcons = {
  Beach: <Beach />,
  Building: <Building />,
  CloudDismiss: <CloudDismiss />,
  Star: <Star />,
  Warning: <Warning />,
};

export const SurfaceIcons = {
  CloudCheckmark: <CloudCheckmark />,
  DataTrending: <DataTrending />,
  Dumbbell: <Dumbbell />,
  People: <People />,
  StarHeart: <StarHeart />,
};
